<template src="./index.html">
</template>
<script>
	import {getdata} from "./data.js"
	export default {
		props: {
			LoginSettingdiag: {
				type: Boolean,
				default: false
			},
			
		},
		data: function() {
			return {
				formlist: getdata().formlist,
				formdata: getdata().formdata,

			};
		},
		watch: {
			LoginSettingdiag: function(indexVal, oldVal) {
				if (indexVal) {

				}
			},
		},
		created() {},
		methods: {
			getdata(){
				
			},
			closediag(){
				this.$emit("closediag","")
			},
		}
	};
</script>


<style scoped lang="less">
	@import url("./index.less");
</style>
